import React, { useEffect, useState } from 'react';
import { ActivityIndicator, View, ScrollView, FlatList } from 'react-native';
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from "react-redux"
import Colors from '../../constants/Colorsv2';
import { TouchableOpacity } from '../../globalComponents/NativeOverrides';
import { social_createPostComment, social_getCommentsForPost, social_getPostById } from '../../store/actionsv1/social';
import { PublicPlayerProps } from '../../store/types/auth_svc';
import { PostCommentProps, PostProps } from '../../store/types/soc_svc';
import PostCard from './components/PostCard';
import PostCommentCard from './components/PostCommentCard';
import RichTextInput from './components/RichTextComponents/RichTextInput';
import RTIToolbar from './components/RichTextComponents/RTIToolbar';
import { comment_getEmptyComment } from './helpers/comments';
import { Helmet } from 'react-helmet-async';

const ActivityDetail = ({navigation, route}:any) => {
    const [ toolbar_visible, setToolbarVisible ] = useState(false);
    const [ loading, setLoading ] = useState(false);
    const [ clear, setClear ] = useState(false);
    const [ draft_comment, setDraftComment ] = useState(comment_getEmptyComment())

    const dispatch = useDispatch();
    const player:PublicPlayerProps = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const viewing_post:PostProps = useSelector((state:any) => state.social.stored_posts.find((p:PostProps) => p.memo_post_id == route.params.post_id), (left, right) => left.memo_post_id == right.memo_post_id)
    const viewing_post_comments:PostCommentProps[] = useSelector((state:any) => state.social.stored_post_comments.filter((pc:PostCommentProps) => pc.activity_post_id == route.params.post_id && pc.status !== 'hidden'), (left, right) => left.length === right.length)
    const app_size:any = useSelector((state:any) => state.util.app_size, (left, right) => left.width == right.width)

    useEffect(() => {
        getPostByIdFromServer(route.params.post_id, route.params.post_type)
    },[route.params.post_id])


    const handleSaveComment = async() => {
        if(!player || !draft_comment){ return navigation.navigate('AuthStack', { screen: 'Login' }) }
        if(draft_comment.message === ''){ return alert('Please include comment') }
        setLoading(true)
        await dispatch(social_createPostComment({ ...draft_comment, player_id: player.player_id, activity_post_id: route.params.post_id }))
        setClear(true)
        setDraftComment(comment_getEmptyComment())
        setLoading(false)        
        
    }

    const handleImageUpload = async(image:any) => {
        if(!player){ return navigation.navigate('AuthStack', { screen: 'Login' }) }
        let comment = comment_getEmptyComment()
        setLoading(true)
        await dispatch(social_createPostComment({ ...comment, comment_images:[image], activity_post_id:route.params.post_id, player_id:player.player_id }))
        setLoading(false)
    }

    const handleVideoUpload = async(video:any) => {
        if(!player){ return navigation.navigate('AuthStack', { screen: 'Login' }) }
        let comment = comment_getEmptyComment()
        setLoading(true)
        await dispatch(social_createPostComment({ ...comment, comment_videos:[video], activity_post_id:route.params.post_id, player_id:player.player_id }))
        setLoading(false)
    }

    const handleOrderUpload = async(orders:string[]) => {
        if(!player){ return navigation.navigate('AuthStack', { screen: 'Login' }) }
        let message = comment_getEmptyComment()
        setLoading(true)
        await dispatch(social_createPostComment({ ...message, comment_orders:orders, player_id:player.player_id, activity_post_id: route.params.post_id }))
        setLoading(false)
    }

    const handleUrlUpload = async(url:string, url_preview:any) => {
        if(!player){ return navigation.navigate('AuthStack', { screen: 'Login' }) }
        let message = comment_getEmptyComment()
        setLoading(true)
        await dispatch(social_createPostComment({ ...message, activity_post_id:route.params.post_id, comment_urls:[url], url_metadata:[url_preview], player_id:player.player_id }))
        setLoading(false)
    }

    const getPostByIdFromServer = async(post_id:string, post_type:string) => {
        setLoading(true)
        await dispatch(social_getPostById(post_id))
        await dispatch(social_getCommentsForPost(post_id, post_type, 0))
        setLoading(false)
    }

    const renderPostComments = (data: { item:PostCommentProps, index:number }) => {
        const last = data.index === viewing_post_comments.length - 1
        return (
            <View style={{ flex:1 }}>
                <View style={{flexDirection:'row'}}>
                    <View style={{width:16, flexDirection:'row'}}>
                        <>
                        <View style={{flex:1/2}}/>
                        <View style={{flex:1/2}}>
                            {data.index === 0 ?
                            <>
                            <View style={{height:40, borderBottomWidth:1, borderColor:Colors.highlights.highlight200}}/>
                            <View style={{flex:1, borderLeftWidth:1, borderColor:Colors.highlights.highlight200}}/>
                            </>
                            :<></>}
                            {data.index !== 0?
                            <>
                            <View style={{height:40, borderLeftWidth:1, borderBottomWidth:1, borderColor:Colors.highlights.highlight200}}/>
                            {last?<></>:
                            <View style={{flex:1, borderLeftWidth:1, borderColor:Colors.highlights.highlight200}}/>
                            }
                            </>
                            :
                            <></>
                            }
                        </View>
                        </>
                    </View>
                    <View style={{flex:1}}>
                        <PostCommentCard post_comment={data.item} comment_width={app_size.width - 20}/>
                    </View>
                </View>
            </View>
        )
    }

    if(!viewing_post || loading){
        return (
            <View style={{ justifyContent:'center', alignItems:'center', padding:20 }}>
                <ActivityIndicator size='large' color={Colors.brand.midnight} />
            </View>
        )
    }
    return (
        <View style={{ flex: 1, backgroundColor:Colors.shades.white }}>
            <Helmet>
                <title>{viewing_post.title}</title>
                <meta name='description' content={viewing_post.body}/>
                <meta name='og:image' content={viewing_post.memo_images[0]?.secure_url ?? 'https://res.cloudinary.com/hoabts6mc/image/upload/v1704746039/be_logo_2_idjbro.png'} />
            </Helmet>
            <ScrollView style={{ flex:1 }}>
                <View style={{ marginBottom:5 }}>
                    <PostCard navigation={navigation} post={viewing_post} view_type='detail'/>
                </View>
                <FlatList data={viewing_post_comments} renderItem={renderPostComments} keyExtractor={(item) => item.post_comment_id.toString()} />
            </ScrollView>
            {toolbar_visible ? 
            <RTIToolbar
                selected_orders={draft_comment.comment_orders??[]}
                onTagOrders={(orders) => handleOrderUpload(orders)}
                onImageUpload={(image) => handleImageUpload(image)} 
                onVideoUpload={(video) => handleVideoUpload(video)} 
                onLinkCreate={(link, link_preview) => handleUrlUpload(link, link_preview)}
                onToolSelect={(tool) => console.log(tool)}
                />
            :<></>}
            <View style={{ flexDirection:'row', alignItems:'center', padding:10, backgroundColor: Colors.shades.white, shadowColor: "rgba(221, 221, 221, 0.6)", shadowOffset: { width: 0, height: -15 }, shadowRadius: 20, shadowOpacity: 1 }}>
                <TouchableOpacity style={{ height:42, width:42, justifyContent:'center', alignItems:'center', marginRight:5 }} onPress={() => setToolbarVisible(true)}>
                    <Icon name='plus' type='feather' color={Colors.brand.midnight} size={20} />
                </TouchableOpacity>
                <View style={{ flex:1, backgroundColor:Colors.shades.shade100, borderRadius:20, padding:10 }}>
                    <RichTextInput clear={clear} onClear={() => setClear(false)} placeholder='Start typing here' onUpdate={(formatted_body, message) => setDraftComment({ ...draft_comment, formatted_body, message })}/>
                </View>
                <TouchableOpacity style={{ height:42, width:42, backgroundColor:Colors.brand.midnight, borderRadius:100, justifyContent:'center', alignItems:'center', marginLeft:10 }} onPress={() => handleSaveComment()}>
                    <Icon name='send' type='feather' size={18} color={Colors.shades.white} />
                </TouchableOpacity>
            </View>
        </View>
    )
}

export default ActivityDetail